"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TELEMETRY_SAFE_PARAMS = void 0;
exports.scrubTelemetryUrl = scrubTelemetryUrl;
exports.scrubUrlsInText = scrubUrlsInText;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _redactTelemetryText = require("./redactTelemetryText");
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Allowlist-based URL scrubbing for telemetry. Host page URLs/referrers carry
 * magic-link reset tokens, numeric shopperIds (`user_id=`) and free-text `initialPrompt=`,
 * so every query (`?k=v&...`) and matrix (`;k=v;...`) param NOT listed here has its value
 * replaced with `[REDACTED]` (the key is kept for debugging). Fragments are always redacted.
 *
 * Manual splitting (not `new URL`) so relative URLs, `GET https://...` span names and malformed
 * input never throw or get normalized. Fails closed: on any error, cut at the first `?`/`;`/`#`.
 */

// Lower-cased. Tracking/marketing params (aligned with getParsedQueryParams), our own API
// request params (so fetch spans and `url` labels stay useful) and non-PII app context.
// Deliberately absent: token, magiclink, action, user_id, shopperid, uid, fqdn, initialprompt, url, ref.
var TELEMETRY_SAFE_PARAMS = exports.TELEMETRY_SAFE_PARAMS = new Set(['gclid', 'fbclid', 'msclkid', 'adleadid', 'ad_lead_id', 'utm_campaign', 'utmcampaign', 'utm_content', 'utmcontent', 'utm_medium', 'utmmedium', 'utm_source', 'utmsource', 'utm_term', 'utmterm', 'utm_id', 'isc', 'itc', 'plid', 'marketid', 'leadsource', 'productintent', 'experiment', 'market', 'currencytype', 'sourceapp', 'source', 'rendermode', 'difyleadgenliveversion', 'customerid']);

// Allowlisted only when the value is a GUID (customerId); anything else (e.g. a numeric shopperId) is PII.
var GUID_ONLY_PARAMS = new Set(['customerid']);
var MAX_VALUE_LENGTH = 256;
// `'` and `)` are valid URL characters (e.g. "Let's%20Web" in pixel params), so they don't end a
// match — stopping early would leave the rest of the URL's params unscrubbed. A trailing quote/paren
// from surrounding prose just ends up in the last path segment or param value.
var URL_IN_TEXT = /\b(?:https?|wss?):\/\/[^\s"<>`\]]+/gi;
function safeDecode(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$keepPlus = _ref.keepPlus,
    keepPlus = _ref$keepPlus === void 0 ? false : _ref$keepPlus;
  try {
    return decodeURIComponent(keepPlus ? value : value.replace(/\+/g, ' '));
  } catch (_unused) {
    return null;
  }
}

// Form encoding turns `+` into a space, which hides the leading `+` of an E.164 phone number
// (`?utm_term=+14805551234`). If the space-decoded value looks clean, check it again with `+` kept.
function redactParamValue(rawValue, value) {
  var redacted = (0, _redactTelemetryText.redactTelemetryText)(value);
  if (redacted !== value || !rawValue.includes('+')) return redacted;
  var literal = safeDecode(rawValue, {
    keepPlus: true
  });
  var literalRedacted = literal == null ? value : (0, _redactTelemetryText.redactTelemetryText)(literal);
  return literalRedacted === literal ? value : literalRedacted;
}
function encodeValue(value) {
  return encodeURIComponent(value).replace(/%5BREDACTED%5D/g, _redactTelemetryText.REDACTED);
}

/** Splits `text` at the first `separator`; the second element is null when it's absent. */
function splitAtFirst(text, separator) {
  var index = text.indexOf(separator);
  return index === -1 ? [text, null] : [text.slice(0, index), text.slice(index + 1)];
}

// Allowlisted values are still checked (e.g. an email address in `utm_content`).
function scrubAllowlistedValue(pair, rawKey, lowerKey, rawValue) {
  var value = safeDecode(rawValue);
  if (value == null || GUID_ONLY_PARAMS.has(lowerKey) && !(0, _redactTelemetryText.isGuid)(value)) return "".concat(rawKey, "=").concat(_redactTelemetryText.REDACTED);
  var redacted = redactParamValue(rawValue, value);
  if (redacted === value && rawValue.length <= MAX_VALUE_LENGTH) return pair;
  return "".concat(rawKey, "=").concat(encodeValue(redacted.slice(0, MAX_VALUE_LENGTH)));
}
function scrubParam(pair) {
  if (pair === '') return pair;
  var _splitAtFirst = splitAtFirst(pair, '='),
    _splitAtFirst2 = (0, _slicedToArray2.default)(_splitAtFirst, 2),
    rawKey = _splitAtFirst2[0],
    rawValue = _splitAtFirst2[1];
  var key = safeDecode(rawKey);

  // A key that is itself PII (e.g. `?foo@bar.com=1`) or undecodable is dropped entirely.
  if (key == null || (0, _redactTelemetryText.redactTelemetryText)(key) !== key) return _redactTelemetryText.REDACTED;
  var lowerKey = key.toLowerCase();
  var isSafe = TELEMETRY_SAFE_PARAMS.has(lowerKey);
  if (rawValue == null) return isSafe ? pair : _redactTelemetryText.REDACTED;
  if (rawValue === '') return pair;
  if (!isSafe) return "".concat(rawKey, "=").concat(_redactTelemetryText.REDACTED);
  return scrubAllowlistedValue(pair, rawKey, lowerKey, rawValue);
}
function failClosed(url) {
  try {
    var cutIndex = url.search(/[?;#]/);
    return cutIndex === -1 ? (0, _redactTelemetryText.redactTelemetryText)(url) : "".concat(url.slice(0, cutIndex), "?").concat(_redactTelemetryText.REDACTED);
  } catch (_unused2) {
    return _redactTelemetryText.REDACTED;
  }
}
function scrubTelemetryUrl(url) {
  if (typeof url !== 'string' || url === '') return url;
  try {
    if (/^\s*data:/i.test(url)) return "data:".concat(_redactTelemetryText.REDACTED);
    var _splitAtFirst3 = splitAtFirst(url, '#'),
      _splitAtFirst4 = (0, _slicedToArray2.default)(_splitAtFirst3, 2),
      beforeHash = _splitAtFirst4[0],
      rawFragment = _splitAtFirst4[1];
    var fragment = rawFragment == null ? '' : "#".concat(rawFragment ? _redactTelemetryText.REDACTED : '');
    var _splitAtFirst5 = splitAtFirst(beforeHash, '?'),
      _splitAtFirst6 = (0, _slicedToArray2.default)(_splitAtFirst5, 2),
      beforeQuery = _splitAtFirst6[0],
      rawQuery = _splitAtFirst6[1];
    var query = rawQuery == null ? '' : "?".concat(rawQuery.split('&').map(scrubParam).join('&'));
    var _beforeQuery$split = beforeQuery.split(';'),
      _beforeQuery$split2 = (0, _toArray2.default)(_beforeQuery$split),
      path = _beforeQuery$split2[0],
      matrixParams = _arrayLikeToArray(_beforeQuery$split2).slice(1);
    return [(0, _redactTelemetryText.redactTelemetryText)(path)].concat((0, _toConsumableArray2.default)(matrixParams.map(scrubParam))).join(';') + query + fragment;
  } catch (_unused3) {
    return failClosed(url);
  }
}

/** Scrubs every absolute URL embedded in free text, then redacts PII in the remaining text. */
function scrubUrlsInText(text) {
  if (typeof text !== 'string' || text === '') return text;
  try {
    return (0, _redactTelemetryText.redactTelemetryText)(text.replace(URL_IN_TEXT, scrubTelemetryUrl));
  } catch (_unused4) {
    return _redactTelemetryText.REDACTED;
  }
}